import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  craftsmen: [],
  craftsman: {},
};

const getters = {
  getCraftsman: (state) => state.craftsman,
  getCraftsmen: (state) => state.craftsmen,
  getCraftsmanById: (state) => (id) => {
    return state.craftsmen.find((item) => item.id == id);
  },
  // Getter to return craftsmen with cover image instead of images array
  getCraftsmenWithCoverImage: (state) => {
    return state.craftsmen.map((craftsman) => {
      // Find the cover image
      const coverImage = craftsman.images.find((image) => image.isCover);

      // Return a new craftsman object
      return {
        ...craftsman,
        // Replace images array with the cover image or null if not found
        coverImage: coverImage || null,
        // Optionally, remove the images array if not needed
        // ...other properties
      };
    });
  },
};

const actions = {
  async fetchCraftsmen_lite({ commit }) {
    try {
      const resp = await api.get("/craftsmen?lite=1");
      if (resp.status == 200) {
        const craftsmen = resp.data.data;
        //console.log("craftsmen", craftsmen);
        commit("setCraftsmen", craftsmen);
      }
    } catch (error) {
      //console.log("error", error);
      return false;
    }
  },
  async fetchCraftsmen({ commit }) {
    try {
      const resp = await api.get("/craftsmen");
      if (resp.status == 200) {
        const craftsmen = resp.data.data;
        //console.log("craftsmen", craftsmen);
        commit("setCraftsmen", craftsmen);
      }
    } catch (error) {
      //console.log("error", error);
      return false;
    }
  },
  async fetchOneCraftsman({ commit }, id) {
    try {
      const resp = await api.get(`/craftsmen/${id}`);
      if (resp.status == 200) {
        const craftsman = resp.data.data;
        //console.log("craftsman", craftsman);
        commit("setCraftsman", craftsman);
      }
    } catch (error) {
      //console.log("error", error);
      return false;
    }
  },
  async updateCraftsman({ commit }, craftsman) {
    try {
      const id = craftsman.id;
      craftsman._method = "patch";
      const resp = await api.post(`/craftsmen/${id}`, craftsman);
      if (resp.status == 200) {
        const craftsman = resp.data.data;

        commit("updateCraftsman", craftsman);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      //console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addCraftsman({ commit }, craftsman) {
    console.log("cccc:", craftsman);
    try {
      const resp = await api.post(`/craftsmen`, craftsman);

      if (resp.status == 201) {
        const craftsman = resp.data.data;

        commit("addCraftsman", craftsman);
      }

      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteCraftsman({ commit }, id) {
    try {
      const resp = await api.delete(`/craftsmen/${id}`);

      ////console.log("resp", resp.data);
      ////console.log("resp delete: ", resp.status);
      if (resp.status == 204) {
        commit("deleteCraftsman", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteCraftsmanImage({ commit }, data) {
    ////console.log("data to delete:", data);
    const id = data.image_id;
    // const craftsman_id = data.image_id;
    try {
      const resp = await api.delete(`/craftsman_images/${id}`);

      ////console.log("resp", resp.data);
      if (resp.status == 204) {
        commit("deleteCraftsmanImage", data);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },

  async addCraftsmanImage({ commit }, image) {
    ////console.log("image", image);
    try {
      const formData = new FormData();
      formData.append("link", image.link);

      formData.append("alt", image.alt);
      formData.append("isCover", image.isCover ? "1" : "0");
      formData.append("craftsman_id", image.craftsman_id);
      const resp = await api.post(`/craftsman_images`, formData);

      if (resp.status == 201) {
        const image = resp.data.data;
        commit("addCraftsmanImage", image);
      }
      ////console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },

  async updateCraftsmanImage({ commit }, image) {
    //console.log("image", image);
    try {
      const formData = new FormData();
      formData.append("image", image.image);

      formData.append("alt", image.alt);
      formData.append("isCover", image.isCover ? "1" : "0");
      formData.append("craftsman_id", image.craftsman_id);
      formData.append("_method", "patch");
      const resp = await api.post(`/craftsman_images/${image.id}`, formData);

      if (resp.status == 201) {
        const image = resp.data.data;
        commit("updateCraftsmanImage", image);
      }
      //console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  addCraftsmanImage(state, image) {
    const index = state.craftsmen.findIndex((p) => p.id == image.craftsman_id);
    if (index != -1) {
      state.craftsmen[index].images.unshift(image);
    }
  },
  updateCraftsmanImage(state, image) {
    const index_craftsman = state.craftsmen.findIndex(
      (p) => p.id == image.craftsman_id
    );
    if (index_craftsman != -1) {
      const index_image = state.craftsmen[index_craftsman].images.findIndex(
        (p) => p.id == image.id
      );
      if (index_image !== -1) {
        state.craftsmen[index_craftsman].images[index_image] = image;
      }
    }
  },
  setCraftsmen(state, craftsmen) {
    state.craftsmen = craftsmen;
  },
  setCraftsman(state, craftsman) {
    state.craftsman = craftsman;
  },
  updateCraftsman(state, craftsman) {
    const id = craftsman.id;
    const index = state.craftsmen.findIndex((craftsman) => craftsman.id == id);
    if (index !== -1) {
      state.craftsmen[index] = craftsman;
    }
  },
  addCraftsman(state, craftsman) {
    state.craftsmen.unshift(craftsman);
  },

  deleteCraftsman(state, id) {
    //console.log("to delete: ", id);
    const index = state.craftsmen.findIndex((p) => p.id == id);
    //console.log("to delete::::", state.craftsmen[index]);
    if (index !== -1) {
      state.craftsmen.splice(index, 1);
    }
  },
  deleteCraftsmanImage(state, data) {
    const index_craftsman = state.craftsmen.findIndex(
      (p) => p.id == data.craftsman_id
    );
    if (index_craftsman != -1) {
      const index_image = state.craftsmen[index_craftsman].images.findIndex(
        (p) => p.id == data.image_id
      );
      if (index_image !== -1) {
        state.craftsmen[index_craftsman].images.splice(index_image, 1);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
